
import ReactDOM from 'react-dom/client';
import 'assets/styles/global.css'
import App from './App';
import { Provider } from "react-redux";
import  {store, persistor}  from "store";
import { PersistGate } from "redux-persist/lib/integration/react";
// require('dotenv').config();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
  <PersistGate loading={<span className="spinner" ></span> } persistor={persistor}>
    <App />
  </PersistGate>
</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

